import { useNavigate } from "react-router-dom";
import m3 from "../assets/photos/ISO/3.jpg";
import m2 from "../assets/photos/ISO/2.jpg"

const Sertifika = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
            padding: "40px 20px"
        }}>
            <h2 style={{ marginBottom: "24px", color: "#1a7373" }}>Sertifikalarımız</h2>
            <div>
                <img
                    src={m3}
                    alt="ISO Sertifikası"
                    style={{ maxWidth: "100%", width: "800px", borderRadius: "8px", boxShadow: "0 4px 20px rgba(0,0,0,0.15)" }}
                />
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 20,
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <div style={{width: "50%", textAlign: "center"}}>ISO 9001: Kalite Yönetim Sertifikası</div>
                    <div style={{width: "50%", textAlign: "center"}}>ISO 14001: Çevre Yönetim Sertifikası</div>
                </div>

            </div>

            <button
                onClick={() => navigate(-1)}
                style={{
                    marginTop: "32px",
                    padding: "10px 24px",
                    backgroundColor: "#1a7373",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "1rem"
                }}
            >
                Geri Dön
            </button>
        </div>
    );
};

export default Sertifika;